import i from 'i18next'

import Panel from '~/components/Panel'
import { FormGroup, Radio } from '~/components/unform'

import { getContextOptions } from '../helpers'
import { useRequestAds } from '../hooks/useRequestAds'

const ContextSection = () => {
  const { setContext } = useRequestAds()

  const handleChangeContext = (e: React.ChangeEvent<HTMLInputElement>) => {
    const context = e.target.value as CampaignContext
    setContext(context)
  }

  return (
    <Panel title={i.t('rm:placements.list.table.column.title.context')}>
      <FormGroup>
        <Radio
          options={getContextOptions()}
          name="context"
          layout="inline"
          required
          itemSize="tiny"
          onChange={handleChangeContext}
        />
      </FormGroup>
    </Panel>
  )
}

export default ContextSection
